import { render } from "./failureMessage.vue?vue&type=template&id=36633c1c&scoped=true"
import script from "./failureMessage.vue?vue&type=script&lang=js"
export * from "./failureMessage.vue?vue&type=script&lang=js"

import "./failureMessage.vue?vue&type=style&index=0&id=36633c1c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36633c1c"]])

export default __exports__